var _defs, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3a669b;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #f5d71c;\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #3f3f3f;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.5,
    cy: 15.5,
    r: 14.7,
    transform: "translate(-.5 30.5) rotate(-88.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.2,15.5c0-1-.1-2-.3-2.9H13.6V.9c-2.1.3-4.1,1-5.9,2.1v9.6H1.1c-.2,1-.3,1.9-.3,2.9s.1,2,.3,3h6.7v9.6c1.8,1.1,3.8,1.8,5.9,2.1v-11.7h16.3c.2-1,.3-1.9.3-3Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15.5,
    cy: 15.5,
    r: 14.7,
    transform: "translate(-.5 30.5) rotate(-88.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.2e29773b6ea71130a8c65076d3d2fcdc.svg";
export { ForwardRef as ReactComponent };